// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.text-sm {
  font-size: 10px !important;
}

.cookieConsentContainer {
  z-index: 999;
  width: 500px;
  min-height: 20px;
  box-sizing: border-box;
  padding: 30px 30px 30px 30px;
  background: rgba(255, 255, 255, 0.9);
  overflow: hidden;
  position: fixed;
  bottom: 30px;
  left: 30px;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;
}

.fa-minus {
  font-size: 12px;
  top: 5px;
  left: -13px;
  position: absolute;
}

.cookieConsentContainer:hover {
  transition: 0.4s;
  background: rgb(255, 255, 255);
}

.cookieConsentContainer .cookieTitle a {
  color: rgba(0, 0, 0, 0.87);
  font-size: 22px;
  line-height: 20px;
  display: block;
}

.cookieConsentContainer .cookieDesc p {
  margin: 0;
  padding: 0;
  color: rgba(0, 0, 0, 0.87);
  font-size: 13px;
  line-height: 20px;
  display: block;
  margin-top: 10px;
}

.cookieConsentContainer .cookieDesc a {
  color: rgba(0, 0, 0, 0.87);
  text-decoration: underline;
}

.cookieConsentContainer .cookieButton a {
  display: inline-block;
  font-size: 14px;
  font-weight: bold;
  margin-top: 14px;
  background: #f7f7f7;
  color: rgba(0, 0, 0, 0.87);
  box-sizing: border-box;
  padding: 15px 24px;
  text-align: center;
  transition: background 0.3s;
}

.cookieConsentContainer .cookieButton a:hover {
  cursor: pointer;
  background: rgb(212, 212, 212);
}

@media (max-width: 980px) {
  .cookieConsentContainer {
    bottom: 0px !important;
    left: 0px !important;
    width: 100% !important;
    background: rgb(255, 255, 255) !important;
  }
}
.i-c-link {
  color: rgba(0, 0, 0, 0.87) !important;
}

.i-c-link:hover {
  color: rgba(0, 0, 0, 0.87) !important;
}

.cookieDesc {
  text-align: justify;
}

.close-box {
  transition: 0.4s;
}

.close-box:hover {
  opacity: 0.8;
}`, "",{"version":3,"sources":["webpack://./src/app/components/cookie-policy/cookie-policy.component.scss","webpack://./src/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,0BAAA;AADF;;AAIA;EACE,YAAA;EACA,YAAA;EACA,gBAAA;EACA,sBAAA;EACA,4BAAA;EACA,oCAAA;EACA,gBAAA;EACA,eAAA;EACA,YAAA;EACA,UAAA;EACA,8DAAA;AADF;;AAIA;EACE,eAAA;EACA,QAAA;EACA,WAAA;EACA,kBAAA;AADF;;AAIA;EACE,gBAAA;EACA,8BAAA;AADF;;AAIA;EACE,0BCdgB;EDehB,eAAA;EACA,iBAAA;EACA,cAAA;AADF;;AAIA;EACE,SAAA;EACA,UAAA;EAEA,0BCxBgB;EDyBhB,eAAA;EACA,iBAAA;EACA,cAAA;EACA,gBAAA;AAFF;;AAKA;EACE,0BChCgB;EDiChB,0BAAA;AAFF;;AAKA;EACE,qBAAA;EAGA,eAAA;EACA,iBAAA;EACA,gBAAA;EACA,mBC9CmB;ED+CnB,0BC5CgB;ED6ChB,sBAAA;EACA,kBAAA;EACA,kBAAA;EACA,2BAAA;AAHF;;AAMA;EACE,eAAA;EACA,8BC/CY;AD4Cd;;AAMA;EACE;IACE,sBAAA;IACA,oBAAA;IACA,sBAAA;IACA,yCAAA;EAHF;AACF;AAMA;EACE,qCAAA;AAJF;;AAOA;EACE,qCAAA;AAJF;;AAOA;EACE,mBAAA;AAJF;;AAOA;EACE,gBAAA;AAJF;;AAOA;EACE,YAAA;AAJF","sourcesContent":["@import \"../../../styles/variables.scss\";\r\n\r\n.text-sm {\r\n  font-size: 10px !important;\r\n}\r\n\r\n.cookieConsentContainer {\r\n  z-index: 999;\r\n  width: 500px;\r\n  min-height: 20px;\r\n  box-sizing: border-box;\r\n  padding: 30px 30px 30px 30px;\r\n  background: rgba(255, 255, 255, 0.9);\r\n  overflow: hidden;\r\n  position: fixed;\r\n  bottom: 30px;\r\n  left: 30px;\r\n  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.075) !important;\r\n}\r\n\r\n.fa-minus {\r\n  font-size: 12px;\r\n  top: 5px;\r\n  left: -13px;\r\n  position: absolute;\r\n}\r\n\r\n.cookieConsentContainer:hover {\r\n  transition: 0.4s;\r\n  background: rgba(255, 255, 255, 1);\r\n}\r\n\r\n.cookieConsentContainer .cookieTitle a {\r\n  color: $main-text-color;\r\n  font-size: 22px;\r\n  line-height: 20px;\r\n  display: block;\r\n}\r\n\r\n.cookieConsentContainer .cookieDesc p {\r\n  margin: 0;\r\n  padding: 0;\r\n\r\n  color: $main-text-color;\r\n  font-size: 13px;\r\n  line-height: 20px;\r\n  display: block;\r\n  margin-top: 10px;\r\n}\r\n\r\n.cookieConsentContainer .cookieDesc a {\r\n  color: $main-text-color;\r\n  text-decoration: underline;\r\n}\r\n\r\n.cookieConsentContainer .cookieButton a {\r\n  display: inline-block;\r\n\r\n  color: $main-text-color;\r\n  font-size: 14px;\r\n  font-weight: bold;\r\n  margin-top: 14px;\r\n  background: $main-content-color;\r\n  color: $main-text-color;\r\n  box-sizing: border-box;\r\n  padding: 15px 24px;\r\n  text-align: center;\r\n  transition: background 0.3s;\r\n}\r\n\r\n.cookieConsentContainer .cookieButton a:hover {\r\n  cursor: pointer;\r\n  background: $white-hover;\r\n}\r\n\r\n@media (max-width: 980px) {\r\n  .cookieConsentContainer {\r\n    bottom: 0px !important;\r\n    left: 0px !important;\r\n    width: 100% !important;\r\n    background: rgba(255, 255, 255, 1) !important;\r\n  }\r\n}\r\n\r\n.i-c-link {\r\n  color: $main-text-color !important;\r\n}\r\n\r\n.i-c-link:hover {\r\n  color: $main-text-color !important;\r\n}\r\n\r\n.cookieDesc {\r\n  text-align: justify;\r\n}\r\n\r\n.close-box {\r\n  transition: 0.4s;\r\n}\r\n\r\n.close-box:hover {\r\n  opacity: 0.8;\r\n}\r\n","// ------------ Fonts -------------\r\n$main-font-family: \"Roboto\", \"Helvetica\", \"Arial\", sans-serif;\r\n\r\n// ------------ MAIN COLORS -------------\r\n$primary-light-blue: #4695e7;\r\n$primary-lighter-blue: #5faffb;\r\n$primary-blue: #253a85;\r\n$primary-dark-blue: #082a54;\r\n$primary-pink: #e06902;\r\n$primary-pink-500: #e06902;\r\n\r\n$primary-200: #082a54;\r\n$primary-500: #253a85;\r\n$primary-800: #082a54;\r\n\r\n// Content\r\n$main-content-color: #f7f7f7;\r\n$light-weight-content: #f9fafd;\r\n$main-content-background-color: #fafafa;\r\n$main-text-color: rgba(0, 0, 0, 0.87);\r\n$loading-background: rgb(35 54 87);\r\n\r\n$gray-white: #d1ecf1;\r\n$white: rgb(255, 255, 255);\r\n$white-weak: rgb(255, 255, 255, 0.5);\r\n$white-hover: rgb(212, 212, 212);\r\n$darker-white: #fefefe;\r\n$mat-title-color: #1e293b;\r\n\r\n// GrayWhite\r\n$gray-white-color: #e9e9e9;\r\n$gray-white-color-hover: #f6f6f6;\r\n\r\n$background-color-soft-blue: rgb(35 54 87);\r\n\r\n// MBL colors\r\n$primary-mbl-green: #008800;\r\n\r\n// --------------------------------\r\n\r\n// ------------- ALERT-------------\r\n// Alert Dark Background\r\n$alert-b-color: #323130;\r\n\r\n// Alert color\r\n$alert-color: rgb(111, 2, 1);\r\n$alert-text-color: rgb(255, 255, 255);\r\n\r\n// Notification color\r\n$notification-color: #fa3e3e;\r\n\r\n// Alert yellow color\r\n$alert-yellow-color: #f6be00;\r\n$alert-yellow-color-light: rgb(253, 244, 164);\r\n$alert-b-color: #323130;\r\n\r\n$text-border: 1px solid rgba(0, 0, 0, 0.1);\r\n$box-shadow: 0 4px 10px 0 rgba(0, 0, 0, 0.1);\r\n\r\n$gray-scale-color: rgb(233, 235, 238);\r\n$gray-logo-color-light: rgb(173, 173, 173);\r\n$gray-logo-color: rgb(132, 132, 132);\r\n$success-color: rgb(83, 189, 120);\r\n\r\n$confirm-color-m: #53bd78;\r\n$alert-color-m: rgba(239, 191, 0, 1);\r\n$alert-safe: #eed202;\r\n$confirm-color-m-weak: rgba(81, 189, 119, 0.129);\r\n$alert-color-m-weak: rgba(239, 191, 0, 0.11);\r\n\r\n$panel-color: #323130;\r\n$lighter-dark: #3c4146;\r\n\r\n$basic-gray: #f1f5f9;\r\n$basic-fuse-gray: #64748b;\r\n\r\n$form-color: rgb(148, 168, 184);\r\n\r\n// --------------------------------"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
